export const cardsBackdrop = 'src/ts/common/components/product/assets/cards_backdrop.png';
export const grayBackdrop = 'src/ts/common/components/product/assets/gray_backdrop.png';
export const ornamentBackdrop = 'src/ts/common/components/product/assets/ornament_backdrop.jpg';
